/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Sep 28 2022
*  File : AppDownloadEvaluationExecutor.ts
*******************************************/

import { isProposeAppDownload, ProposeAppDownload } from "../../EvaluatedAction.js";
import { ClientSdkPublicInterface } from "../../../sdk/ClientSdkPublicInterface.js";
import { Logger } from "@ciaopeople/cp-shatsu/Logging";
import { CTAExecutionResult, EvaluatedActionExecutor, isDismissedCTA, NamedCtaEvaluator } from "../EvaluatedActionExecutor.js";
import { executeAppDownload } from "../evaluations/NativeAppActionsProposal.js";

export class AppDownloadEvaluationExecutor implements EvaluatedActionExecutor {
    public isExpectedType = isProposeAppDownload;

    constructor(
        private readonly sdk: ClientSdkPublicInterface,
        private logger: Logger
    ) {

    }

    execute(evaluator: NamedCtaEvaluator, res: ProposeAppDownload, data?: any): Promise<CTAExecutionResult> {
        return this.sdk.getGui().then(
            gui => {
                return gui.suggestAppDownload(res.data).then(
                    yes => {
                        if (isDismissedCTA(yes)) {
                            return CTAExecutionResult.DISMISSED;
                        }
                        else if (yes) {
                            return executeAppDownload(res.data, this.sdk).then(
                                () => CTAExecutionResult.COMPLETED
                            );
                        }
                        else {
                            return Promise.resolve(CTAExecutionResult.NOT_EXECUTED);
                        }
                    }
                );
            }
        );
    }
}
